module.exports = __webpack_public_path__ + "static/osim-logo-1603ea7171563920d71511c13b41f637.png";